var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "inter_list" } },
    _vm._l(_vm.data, function (item, index) {
      return _c(
        "p",
        {
          key: index,
          class: _vm.styleColor == index ? "styleCol" : "",
          on: {
            click: function ($event) {
              return _vm.rightBtn(index)
            },
          },
        },
        [_vm._v(_vm._s(item))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }